const STORAGE_KEY = 'commissionUnlockToken';

export function getCommissionUnlockToken() {
  return sessionStorage.getItem(STORAGE_KEY) || '';
}

export function setCommissionUnlockToken(token) {
  if (token) sessionStorage.setItem(STORAGE_KEY, token);
  else sessionStorage.removeItem(STORAGE_KEY);
}

export function clearCommissionUnlock() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function commissionHeaders(extra = {}) {
  const unlock = getCommissionUnlockToken();
  return {
    ...extra,
    ...(unlock ? { 'X-Commission-Unlock': unlock } : {})
  };
}

export async function verifyCommissionOtp({ apiBaseUrl, role, otp }) {
  const token = localStorage.getItem('authToken');
  const path = role === 'agency' ? '/agency/commission-access/verify' : '/school/commission-access/verify';
  const response = await fetch(`${apiBaseUrl}${path}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({ otp })
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || 'Invalid OTP');
  }
  setCommissionUnlockToken(data.unlock_token);
  return data;
}
